import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

export function useHeroLoop(count: number, duration: number) {
  const reduce = useReducedMotion();
  const [index, setIndex] = useState(0);
  const autoplay = !reduce;

  useEffect(() => {
    if (!autoplay) return;
    const timer = window.setTimeout(() => setIndex((i) => (i + 1) % count), duration);
    return () => window.clearTimeout(timer);
  }, [index, autoplay, count, duration]);

  return { index, setIndex, autoplay };
}
